import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

interface CallToActionProps {
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
}

const CallToAction = ({
  title,
  description,
  buttonText,
  buttonLink,
  secondaryButtonText,
  secondaryButtonLink,
}: CallToActionProps) => {
  return (
    <section className="bg-primary text-white py-16 md:py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <motion.h2 
            className="font-sans text-3xl md:text-4xl font-bold mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            {title}
          </motion.h2>
          
          <motion.p 
            className="text-lg text-neutral-100 mb-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            {description}
          </motion.p>
          
          <motion.div 
            className="flex flex-wrap justify-center gap-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <a 
              href={buttonLink} 
              className="btn bg-white text-primary-dark hover:bg-neutral-100 inline-flex items-center gap-2"
              target="_blank" 
              rel="noopener noreferrer"
            >
              {buttonText}
              <ArrowRight size={18} />
            </a>
            
            {secondaryButtonText && secondaryButtonLink && (
              <a 
                href={secondaryButtonLink} 
                className="btn border-2 border-white text-white hover:bg-white/10"
              >
                {secondaryButtonText}
              </a>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;